import { render, staticRenderFns } from "./translate_text_list.vue?vue&type=template&id=0b71f20a"
import script from "./translate_text_list.vue?vue&type=script&lang=js"
export * from "./translate_text_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports